import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

interface HeaderProps {
  width?: number;
  height?: number;
}
const Header: React.FC<HeaderProps> = ({ width = 100, height = 100 }) => {
  const theme = useTheme();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      textAlign="center"
    >
      <img src="/icons/logo.png" alt="لوگو" width={width} height={height} />
      <Typography
        variant="h6"
        component="div"
        mb={2}
        textAlign="center"
        sx={{
          fontFamily: "IRANSansXBold",
          size: "24px",
          lineHeight: "72px",
          color: theme.palette.primary.main,
        }}
      >
        مرکزمدیریت حوزه علمیه اصفهان
      </Typography>
    </Box>
  );
};

export default Header;
